import React from "react";
import {useFormContext} from "react-hook-form";
import {FilterComponent} from "./FilterComponent";
import {useTranslation} from "react-i18next";

function ProductIndex(): React.ReactElement {
    const form = useFormContext();
    const {t} = useTranslation();

    return (
        <FilterComponent title={t('user-page.invoice.filters.product-index')} >
            <input type={'text'} {...form.register('product-index')} />
        </FilterComponent>
    );
}

export {ProductIndex};